import {useEffect, useState} from "react";
import {searchInit} from "./init/searchInit";
import {useMutation} from "@tanstack/react-query";
import useGoToNavigation from "../../../../util/useGotoNavigation";
import {exportAccountExcelApi, readAccountlistApi} from "../../../../api/correspondent/CorresspondentApi";
import {CreateCorrespondentInterface} from "../create/interface/CreateCorrespondentInterface";
import {useModal} from "../../../../hooks";
import {PaginationMain} from "../../../../components/common/pagination/PaginationMain";
import {useSearchParams} from "react-router-dom";
import {AccountSearchInterface} from "./interface/searchInterface";
import {downloadFile} from "../../../../util/FileDownload";
import moment from "moment/moment";
import {AxiosError} from "axios";
import AuthorityChecker from "../../../../components/common/authorityGuard/AuthorityChecker";

export interface ListPropsType {
    handleAllCheckboxChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    searchData?: CreateCorrespondentInterface[];
    goToNavigation?: (
        url: string | -1 | number,
        state: {},
        isTrue: boolean
    ) => void;
    checkedItems?: Set<string>;
    handleCheckboxChange?: (
        e: React.ChangeEvent<HTMLInputElement>,
        accountId: string
    ) => void;
}

const CorrespondentListTable = ({
                                    handleAllCheckboxChange,
                                    searchData,
                                    goToNavigation,
                                    checkedItems,
                                    handleCheckboxChange,
                                }: ListPropsType) => {
    const allChecked = searchData?.length !== 0 && searchData?.every(el => checkedItems?.has(el.accountId))

    return (
        <div className="table_scroll">
            <table className="table table-bordered my_table">
                <thead>
                <tr>
                    {/*<th style={{width: "4%"}}>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            checked={allChecked}
                            onChange={handleAllCheckboxChange}
                        />
                    </th>*/}
                    <th>회사명</th>
                    <th style={{width: "20%"}}>ERP 거래처</th>
                    <th style={{width: "12%"}}>소속분류</th>
                    <th style={{width: "12%"}}>산업구분</th>
                    <th style={{width: "12%"}}>기본 연락처</th>
                    <th style={{width: "10%"}}>담당자</th>
                    <th style={{width: "6%"}}>상태</th>
                </tr>
                </thead>
                <tbody>
                {searchData && searchData.length > 0 ? (
                    searchData.map((item: any) => (
                        <tr
                            key={item.accountId}
                            className="clickable"
                            onClick={() =>
                                goToNavigation &&
                                goToNavigation(
                                    `customer/correspondent/detail/${item.accountId}`,
                                    item,
                                    false
                                )
                            }
                        >
                            {/*<td
                                className="text-center"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={checkedItems && checkedItems.has(item.accountId)}
                                    onChange={(e) =>
                                        handleCheckboxChange &&
                                        handleCheckboxChange(e, item.accountId)
                                    }
                                />
                            </td>*/}
                            {/* 회사명 */}
                            <td>{item.name || "-"}</td>
                            {/* ERP 거래처 */}
                            <td>{item.erpAccountName || "-"}</td>
                            {/* 소속분류 */}
                            <td className="text-center">{item.customerCategoryName || "-"}</td>
                            {/* 산업구분 */}
                            <td className="text-center">{item.industryName || "-"}</td>
                            {/* 기본 연락처 */}
                            <td className="text-center">{item.defaultContact || "-"}</td>
                            {/* 담당자 */}
                            <td className="text-center">{item.chargeName || "-"}</td>
                            {/* 상태 */}
                            <td className="text-center">{item.stateCodeName || "-"}</td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={6} className="text-center">
                            데이터가 없습니다.
                        </td>
                    </tr>
                )}
                </tbody>
            </table>
        </div>
    );
};

export const CorrespondentList = () => {
    const {handleModal} = useModal();

    const [searchData, setSearchData] = useState<CreateCorrespondentInterface[]>(
        []
    );
    const [dataCount, setDataCount] = useState(0);
    const [searchParam, setSearchParam] = useState(searchInit);
    const {goToNavigation} = useGoToNavigation();
    const [checkedItems, setCheckedItems] = useState<Set<string>>(new Set());
    const page = Number(useSearchParams()[0].get("pageNo")) || 1;

    const handleAllCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = e.target.checked;

        if (isChecked) {
            // @ts-ignore
            setCheckedItems(new Set([...checkedItems, ...searchData.map((item: any) => item.accountId)]))
        } else {
            // @ts-ignore
            const list = [...checkedItems].filter(el => !searchData.map(el => el.accountId).includes(el))

            setCheckedItems(new Set(list))
        }
    };

    const handleCheckboxChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        accountId: string
    ) => {
        const newCheckedItems = new Set(checkedItems);
        e.target.checked
            ? newCheckedItems.add(accountId)
            : newCheckedItems.delete(accountId);
        setCheckedItems(newCheckedItems);
    };

    const deleteItems = () => {
        if (checkedItems.size > 0) {
            handleModal({
                isOpen: true,
                contents: "선택된 거래처를 삭제하시겠습니까?",
                type: "confirm",
                callback: () => {
                },
            });
        } else {
            handleModal({
                isOpen: true,
                contents: "삭제할 거래처를 선택해주세요.",
                type: "alert",
            });
        }
    };

    const exportExcel = () => {
        exportExcelDownloadApiMutate(searchParam)
    }

    const readAccountlistApiMutate = useMutation({
        mutationFn: () => readAccountlistApi(searchParam),
        onSuccess: (res) => {
            if (res.data.code === "0000") {
                setSearchData(res.data.result.accountVOList);
                setDataCount(res.data.result.totalCount);
            } else {
            }
        },
        onError: (res) => {
            alert(res);
        },
    });

    const {mutate: exportExcelDownloadApiMutate} = useMutation({
        mutationFn: (data: AccountSearchInterface) => exportAccountExcelApi(data),
        onSuccess: (res) => {
            if (res instanceof Blob) {
                downloadFile(
                    res,
                    `거래처_목록_${moment(new Date()).format("YYYY_MM_DD")}.xlsx`
                );
            }
        },
        onError: (error: AxiosError) => {
            console.log(error);
            if (error?.response?.data instanceof Blob) {
                error.response.data.text().then((value) => {
                    const obj = JSON.parse(value);
                    handleModal({
                        isOpen: true,
                        contents: obj?.msg,
                        type: "alert"
                    });
                });
            }
        },
    });

    useEffect(() => {
        readAccountlistApiMutate.mutate();
    }, []);

    useEffect(() => {
        setSearchParam({...searchParam, pageNo: page});
    }, [page]);

    useEffect(() => {
        readAccountlistApiMutate.mutate();
    }, [searchParam.pageNo]);

    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">거래처 검색</h3>
                    <div className="filter_toolbar"></div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label htmlFor="" className="form-label frm_label">
                                검색어
                            </label>
                            <select
                                className="form-select"
                                onChange={(e) =>
                                    setSearchParam({
                                        ...searchParam,
                                        keywordType: e.target.value,
                                    })
                                }
                            >
                                <option value={"0"}>전체</option>
                                <option value={"1"}>회사명</option>
                                <option value={"2"}>담당자</option>
                                <option value={"3"}>ERP 거래처명</option>
                            </select>
                            <input
                                type="text"
                                className="form-control"
                                onChange={(e) =>
                                    setSearchParam({...searchParam, keyword: e.target.value})
                                }
                                onKeyDown={(e) =>
                                    e.key === "Enter"
                                        ? (() => {
                                            setSearchParam({...searchParam, pageNo: 1});
                                            readAccountlistApiMutate.mutate();
                                        })()
                                        : ''
                                }
                            />
                            <button
                                className="btn btn-info btn_search"
                                onClick={() => {
                                    if (searchParam.pageNo && searchParam.pageNo === 1) {
                                        readAccountlistApiMutate.mutate();
                                    } else {
                                        setSearchParam({...searchParam, pageNo: 1});
                                        goToNavigation(
                                            "customer/correspondent/list?pageNo=1",
                                            {},
                                            false
                                        );
                                    }
                                }}
                            >
                                <img
                                    src={
                                        process.env.PUBLIC_URL + "/assets/images/icon_search.png"
                                    }
                                    alt=""
                                />
                                조회
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">
                        거래처 목록(<span>{dataCount}</span>건)
                    </h6>
                    <div className="table_toolbar">
                        <button className="btn btn-dark w-150px px-0" onClick={exportExcel}>
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"}
                                alt=""
                            />
                            엑셀 내보내기
                        </button>
                        <AuthorityChecker authorityNames={['clientWriteYn']}>
                            <button
                                className="btn btn-primary ms-40px"
                                onClick={() =>
                                    goToNavigation("customer/correspondent/create", "", false)
                                }
                            >
                                거래처 생성
                            </button>
                        </AuthorityChecker>
                    </div>
                </div>

                <CorrespondentListTable
                    handleAllCheckboxChange={handleAllCheckboxChange}
                    searchData={searchData}
                    goToNavigation={goToNavigation}
                    checkedItems={checkedItems}
                    handleCheckboxChange={handleCheckboxChange}
                />

                <PaginationMain totalCount={dataCount ?? 0}/>
            </div>
        </>
    );
};
